import { render, staticRenderFns } from "./OrderExtraInfo.vue?vue&type=template&id=7da2a24b&scoped=true"
import script from "./OrderExtraInfo.vue?vue&type=script&lang=ts"
export * from "./OrderExtraInfo.vue?vue&type=script&lang=ts"
import style0 from "./OrderExtraInfo.vue?vue&type=style&index=0&id=7da2a24b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da2a24b",
  null
  
)

export default component.exports